module.exports = __webpack_public_path__ + "static/img/btn_qrcode_close@3x.c8427a6f.png";